var jQuery = require('jquery');
var _ = require('lodash');
var rxSwitchboard = require('ub/control/rx-switchboard');

(function() {
  function init() {
    var pageSectionSelector = '.lp-pom-block:visible';
    var $viewport = jQuery("[data-role=viewport]");

    function isScrollPositionOutOfBound() {
      var $lastPageSection = $viewport.find(pageSectionSelector + ':last');
      return ($lastPageSection.length > 0) && $lastPageSection.offset().top <= 0 &&
        $lastPageSection.offset().top + $lastPageSection.outerHeight() <= 0;
    }

    function sumOfHeights($elements) {
      return _.reduce(_.map($elements, function($elm) {
        return jQuery($elm).outerHeight(true);
      }), function(sum, val) {
        return sum + val;
      });
    }

    function sumOfHeightsOfAllPageSections() {
      return sumOfHeights($viewport.find(pageSectionSelector));
    }

    function sumOfHeightsOfAllButLastPagesection() {
      return sumOfHeights($viewport.find(pageSectionSelector + ':not(:last)'));
    }

    function rootElementPadding() {
      return jQuery('#lp-pom-root').innerHeight() - sumOfHeightsOfAllPageSections();
    }

    function lastPageSectionOverflow() {
      return $viewport.find(pageSectionSelector + ':last').outerHeight(true) - $viewport.outerHeight(true);
    }

    function sumOfResults(fns) {
      return _.reduce(fns, function(sum, fn) {
        return sum + fn();
      }, 0);
    }

    rxSwitchboard.subjects.jui_events
      .filter(function(ev) {
        return ev.type === 'breakpointChanged' &&
          isScrollPositionOutOfBound();
      })
      .subscribe(function() {
        $viewport.scrollTop(sumOfResults([rootElementPadding, lastPageSectionOverflow, sumOfHeightsOfAllButLastPagesection]));
      });
  }

  rxSwitchboard.subjects
    .first_page_load
    .subscribe(init);
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/viewport-positioning.js
// module id = 1067
// module chunks = 0